define(function(require,exports,module){
    return function(feetDashInches){
        var divider = (feetDashInches.indexOf("_") > -1) ? "_" : "\' ";
        var feetCommaInches=(feetDashInches+"").split(divider);

        return (~~feetCommaInches[0]) + ((~~feetCommaInches[1])/ 12);

    }
});
